import { render, staticRenderFns } from "./permissionsApi-add.vue?vue&type=template&id=e1e06800&"
import script from "./permissionsApi-add.vue?vue&type=script&lang=js&"
export * from "./permissionsApi-add.vue?vue&type=script&lang=js&"
import style0 from "./permissionsApi-add.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports